<template>
  <div >
    <HomeHero />
    <SkillsSection />
    <TestimSlider :normalQuotes="true"/>
    <Partners />
    <Eestec />
  </div>
</template>

<script>
import HomeHero from '@/components/home-components/HomeHero'
import SkillsSection from '@/components/home-components/SkillsSection'
import TestimSlider from '@/components/home-components/TestimSlider'
import Partners from '@/components/home-components/Partners'
import Eestec from '@/components/home-components/Eestec'


export default {
  name: 'home',
  components: {
    HomeHero,
    TestimSlider,
    Partners,
    Eestec,
    SkillsSection,
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss">

</style>
